import { Water, LifePreserver, Recycle, CloudRain, ThermometerHalf, Moisture } from 'react-bootstrap-icons';


const StationMetricTypeIcon = function({ qualifier }) {
	

	let measurementIcon = <Water />;
	switch(qualifier) {
		case "Rainfall":
			measurementIcon = <CloudRain />
			break;
		case "Sewage Discharge":
		case "Sewage Discharge Live":
			measurementIcon = <Recycle />;
			break;
		case "Tidal":
			measurementIcon = <LifePreserver />;
			break;
		case 'WaterTemperature':
			measurementIcon = <ThermometerHalf />;
			break;
		case 'Groundwater Level':
			measurementIcon = <Moisture />
			break;
		default:
			measurementIcon = <Water />;
			break;
	}

	return measurementIcon;
}

export default StationMetricTypeIcon;